import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../../utils/error";
import { useRequest } from "../../../utils/request";
import { accountBondingLineQueryKey } from "../account.keys";

export type AdminAccountBondingLines = Dtos.Admin.SuretyAccountBondingLines.Get.Response;

export const useAdminFetchAccountBondingLines = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isFetching, isLoading, refetch } = useQuery({
		queryKey: accountBondingLineQueryKey(accountId),
		queryFn: async () => {
			try {
				return await get<AdminAccountBondingLines>(
					`/v2/admin/surety/accounts/${accountId}/bonding-lines`,
				);
			} catch (error) {
				if (error instanceof ApiError && error.statusCode === 404) {
					return null;
				}
				throw error;
			}
		},
		retry: false,
		meta: { suppressErrorModal: true },
	});

	return {
		bondingLines: data,
		bondingLinesError: error,
		bondingLinesIsFetching: isFetching,
		bondingLinesIsLoading: isLoading,
		refetchBondingLines: refetch,
	};
};
